import { RouteObject } from "react-router-dom";
import ProtectedOutlet from "components/ProtectedOutlet";
import { ClaimResource } from "types/claimTypes";

import CertificateList from "pages/CertificatePage/CertificateList";
import CertificateDetails from "pages/CertificatePage/CertificateDetails";
import CertificateCreateForm from "pages/CertificatePage/CertificateCreateForm";
import CertificateUpdateForm from "pages/CertificatePage/CertificateUpdateForm";

import CertificateThemeList from "pages/CertificateThemePage/CertificateThemeList";
import CertificateThemeDetails from "pages/CertificateThemePage/CertificateThemeDetails";
import CertificateThemeCreateForm from "pages/CertificateThemePage/CertificateThemeCreateForm";
import CertificateThemeUpdateForm from "pages/CertificateThemePage/CertificateThemeUpdateForm";

import CertificateTemplateList from "pages/CertificateTemplatePage/CertificateTemplateList";
import CertificateTemplateDetails from "pages/CertificateTemplatePage/CertificateTemplateDetails";
import CertificateTemplateCreateForm from "pages/CertificateTemplatePage/CertificateTemplateCreateForm";
import CertificateTemplateUpdateForm from "pages/CertificateTemplatePage/CertificateTemplateUpdateForm";

import CertificatesPage from "pages/CertificateMenuPage";

export const certificatesRoutes: RouteObject[] = [
  {
    element: <ProtectedOutlet claims={[ClaimResource.Certificates]} />,
    children: [
      { path: "certificates", element: <CertificateList /> },
      { path: "certificates/new", element: <CertificateCreateForm /> },
      { path: "certificates/-/:id", element: <CertificateDetails /> },
      { path: "certificates/edit/:id", element: <CertificateUpdateForm /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.CertificateThemes]} />,
    children: [
      { path: "themes", element: <CertificateThemeList /> },
      { path: "themes/new", element: <CertificateThemeCreateForm /> },
      { path: "themes/-/:id", element: <CertificateThemeDetails /> },
      { path: "themes/edit/:id", element: <CertificateThemeUpdateForm /> },
    ],
  },
  {
    element: <ProtectedOutlet claims={[ClaimResource.CertificateTemplates]} />,
    children: [
      { path: "templates", element: <CertificateTemplateList /> },
      { path: "templates/new", element: <CertificateTemplateCreateForm /> },
      { path: "templates/-/:id", element: <CertificateTemplateDetails /> },
      { path: "templates/edit/:id", element: <CertificateTemplateUpdateForm /> },
    ],
  },
  { index: true, element: <CertificatesPage /> },
];
